import React from "react";
import {Helmet} from "react-helmet";
import { useLanguage } from '../includes/LanguageContext.js';
const Policy=()=>{
    const { currentLanguage, selectedLanguage, setSelectedLanguage } = useLanguage();
    const bulletStyle = {
        paddingLeft: '2.2rem',
        marginBottom: '1rem',
        };

    const listItemStyle = {
        marginBottom: '0.5rem',
        };
    return(
        <>
        <Helmet>
                <meta charSet="utf-8" />
                <title>Policy Page</title>
                <link rel="canonical" href="http://mysite.com/example" />
                <meta name="description" content="Helmet application" />
        </Helmet>

        <div className="container-fluid"> 
            <div className="row p-3">
            <div className="col-md-2"></div>
            <div className="col-md-8">
                    <h1>{currentLanguage.Policy.head.title}</h1>
                    <hr className="border border-danger border-2 opacity-50 w-25"/>
                <div className="row">
                    <p>
                    {currentLanguage.Policy.head.desc}
                    </p>
                    <p className="contentHeading">{currentLanguage.Policy.Guidelines.title}</p>
                    <ul style={bulletStyle}>
                        {currentLanguage.Policy.Guidelines.items.map((point, index) => (
                            // <li key={index} className="mb-2" style={listItemStyle}>{point}</li>
                            <li
                                key={index}
                                className="mb-2"
                                style={listItemStyle}
                                dangerouslySetInnerHTML={{ __html: point }}
                                />
                        ))}
                    </ul>
                    <p className="contentHeading">{currentLanguage.Policy.Ownership.title}</p>
                    <ul style={bulletStyle}>
                        {currentLanguage.Policy.Ownership.items.map((point, index) => {
                            // Case 1: Plain string item
                            if (typeof point === "string") {
                            return (
                                <li
                                key={index}
                                className="mb-2"
                                style={listItemStyle}
                                dangerouslySetInnerHTML={{ __html: point }}
                                />
                            );
                            }

                            // Case 2: Object with subitems
                            if (typeof point === "object" && point.text && point.subitems) {
                            return (
                                <li key={index} className="mb-2" style={listItemStyle}>
                                <span dangerouslySetInnerHTML={{ __html: point.text }} />
                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "5px" }}>
                                    {point.subitems.map((subitem, subIndex) => (
                                    <li
                                        key={subIndex}
                                        className="mb-1"
                                        style={listItemStyle}
                                        dangerouslySetInnerHTML={{ __html: subitem }}
                                    />
                                    ))}
                                </ul>
                                </li>
                            );
                            }

                            return null;
                        })}
                        </ul>
                    <p className="contentHeading">{currentLanguage.Policy.Formatting.title}</p>
                    <ul style={bulletStyle}>
                        {currentLanguage.Policy.Formatting.items.map((point, index) => (
                            // <li key={index} className="mb-2" style={listItemStyle}>{point}</li>
                            <li
                                key={index}
                                className="mb-2"
                                style={listItemStyle}
                                dangerouslySetInnerHTML={{ __html: point }}
                                />
                        ))}
                    </ul>
                    <p className="contentHeading">{currentLanguage.Policy.restrictedMaterial.title}</p>
                    <p>
                    {currentLanguage.Policy.restrictedMaterial.head}
                    </p>
                    <ul style={bulletStyle}>
                        {currentLanguage.Policy.restrictedMaterial.items.map((point, index) => (
                            // <li key={index} className="mb-2" style={listItemStyle}>{point}</li>
                            <li
                                key={index}
                                className="mb-2"
                                style={listItemStyle}
                                dangerouslySetInnerHTML={{ __html: point }}
                                />
                        ))}
                    </ul>
                    <p className="contentHeading">{currentLanguage.Policy.RemovalPolicy.title}</p>
                    <p>{currentLanguage.Policy.RemovalPolicy.head}</p>
                    <p>{currentLanguage.Policy.RemovalPolicy.email}</p>
                    <p>{currentLanguage.Policy.RemovalPolicy.foot}</p>
                    <p className="contentHeading">{currentLanguage.Policy.CommunityEthics.title}</p>
                    <ul style={bulletStyle}>
                        {currentLanguage.Policy.CommunityEthics.items.map((point, index) => (
                            // <li key={index} className="mb-2" style={listItemStyle}>{point}</li>
                            <li
                                key={index}
                                className="mb-2"
                                style={listItemStyle}
                                dangerouslySetInnerHTML={{ __html: point }}
                                />
                        ))}
                    </ul>
                    <p className="contentHeading">{currentLanguage.Policy.Acceptance.title}</p>
                    <p>
                    {currentLanguage.Policy.Acceptance.desc}
                    </p>
                    <p>{currentLanguage.Policy.Acceptance.note}
                    </p>
                    <p>
                    {currentLanguage.Policy.Acceptance.note2}
                    </p>

                </div>    

            </div>
            <div className="col-md-2"></div>
            </div>
        </div>
        </>
    )
}

export default Policy;